import { render, staticRenderFns } from "./settlement-purchases-promotee.vue?vue&type=template&id=3cf34546&scoped=true&"
import script from "./settlement-purchases-promotee.vue?vue&type=script&lang=js&"
export * from "./settlement-purchases-promotee.vue?vue&type=script&lang=js&"
import style0 from "./settlement-purchases-promotee.vue?vue&type=style&index=0&id=3cf34546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf34546",
  null
  
)

export default component.exports